import type { CityConfig } from "../city-template/types";

export const pearlandConfig: CityConfig = {
  city: "Pearland",
  state: "Texas",
  stateAbbr: "TX",
  slug: "pearland",
  route: "/cities/pearland",
  title: "Emergency Passport Pearland, TX — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Pearland, TX — as fast as 24 hours. Serving Brazoria County and Houston's fastest-growing suburb. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Pearland, TX",
  heroSubtitle: "Houston metro business trip to Brazil with two weeks notice? Family cruise from Galveston and your passport expired? Johnson Space Center contractor needing urgent international travel? We help Pearland residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Pearland%20Texas%20suburban%20cityscape%20with%20modern%20residential%20neighborhoods%20and%20master%20planned%20communities%20in%20Brazoria%20County%20Houston%20metro%20area%20at%20golden%20hour%20warm%20Gulf%20Coast%20sunset%20colors%20professional%20drone%20photography%20vibrant%20warm%20tones&width=1800&height=700&seq=pearland-hero-tx-2026&orientation=landscape",
  heroImageAlt: "Pearland Texas Brazoria County suburban neighborhoods at golden hour Houston metro",
  geoPosition: "29.5636;-95.2860",
  geoPlacename: "Pearland, Texas",
  regionalAgency: {
    name: "Houston Passport Agency",
    address: "1919 Smith Street, Suite 700, Houston, TX 77002",
    distance: "Located in downtown Houston — approximately 20 miles north of Pearland via TX-288",
  },
  nearbyCitiesZips: [
    { name: "Pearland", zips: "77581, 77584, 77588" },
    { name: "Friendswood", zips: "77546, 77549" },
    { name: "Manvel", zips: "77578" },
    { name: "Alvin", zips: "77511, 77512" },
    { name: "League City", zips: "77573, 77574" },
    { name: "Webster", zips: "77598" },
    { name: "Clear Lake", zips: "77058, 77059, 77062" },
    { name: "Pasadena", zips: "77501–77507" },
    { name: "Deer Park", zips: "77536" },
    { name: "La Porte", zips: "77571, 77572" },
    { name: "Sugar Land", zips: "77478, 77479, 77487, 77498" },
    { name: "Missouri City", zips: "77459, 77489" },
    { name: "Katy", zips: "77449, 77450, 77493, 77494" },
    { name: "Houston", zips: "77001–77099" },
    { name: "Galveston", zips: "77550–77555" },
    { name: "Texas City", zips: "77590, 77591, 77592" },
    { name: "Angleton", zips: "77515, 77516" },
    { name: "Lake Jackson", zips: "77566" },
    { name: "Baytown", zips: "77520, 77521, 77522, 77523" },
    { name: "The Woodlands", zips: "77380–77389" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Brazoria County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Houston Metro Coverage", desc: "Serving Pearland, Friendswood, Alvin, and the Bay Area" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Houston, TX", route: "/cities/houston" },
    { name: "Fast passport renewal in Pasadena, TX", route: "/cities/pasadena-tx" },
    { name: "Emergency passport help in Sugar Land, TX", route: "/cities/sugar-land" },
    { name: "Urgent passport services in Galveston, TX", route: "/galveston" },
    { name: "Passport courier services in Austin, TX", route: "/cities/austin" },
    { name: "Same-day passport help in Dallas, TX", route: "/cities/dallas" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Pearland remotely via secure courier. We do not have a walk-in office in Pearland — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Brazoria County and the Bay Area Houston region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Brazoria County and the Bay Area Houston region including Harris and Galveston counties",
  serviceAreaIntro: "From the master-planned communities of Shadow Creek Ranch and Silverlake to the charming small towns of Friendswood and Alvin, from the bustling NASA corridor of Clear Lake and Webster to the Gulf Coast charm of Galveston, from the energy hubs of Pasadena and Deer Park to the family neighborhoods of Sugar Land and Missouri City — Fast Passport Center serves the entire Pearland and Bay Area Houston region. We regularly help Brazoria County travelers get their passports fast without the downtown Houston traffic.",
  nearbyCitiesIntro: "We serve all Pearland neighborhoods and the surrounding Houston metro area including Friendswood, Manvel, Alvin, League City, Webster, Clear Lake, Pasadena, Deer Park, La Porte, Sugar Land, Missouri City, Katy, Houston, Galveston, Texas City, Angleton, Lake Jackson, and Baytown. If you are anywhere in Brazoria County, the Bay Area, or the southern Houston metro, we have you covered.",
  howItWorksIntro: "Most Pearland travelers complete everything online and ship documents overnight. No need to battle Houston traffic to the downtown passport agency.",
  mistakesIntro: "Pearland travelers often face the headache of driving to downtown Houston for the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Pearland and Brazoria County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Pearland? Here are the most common ones we hear from Bay Area Houston travelers.",
  statePageRoute: "/states/texas",
  statePageName: "Texas",
  dmvWebsite: "https://www.dps.texas.gov",
  dmvLabel: "Texas DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Pearland travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Patricia L.",
      location: "Pearland, TX",
      rating: 5,
      text: "My passport expired right before our cruise from Galveston. Fast Passport Center had my renewal in 27 hours. I never left Pearland. Their Bay Area service is incredible for Brazoria County families.",
      service: "Passport Renewal",
    },
    {
      name: "Robert C.",
      location: "Friendswood, TX",
      rating: 5,
      text: "Emergency passport for a JSC contractor trip to the ISS conference in Germany. Got it in 29 hours. Fast Passport Center handled everything — I didn't have to drive to downtown Houston. Game changer for NASA corridor professionals.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda R.",
      location: "Manvel, TX",
      rating: 5,
      text: "First passport for my 8-year-old before our trip to Costa Rica. Fast Passport Center walked us through every form and had her passport in 4 days. So easy for Pearland families.",
      service: "Child Passport",
    },
    {
      name: "Kevin M.",
      location: "Pearland, TX",
      rating: 5,
      text: "Lost my passport 3 days before flying to Tokyo. Fast Passport Center had a replacement in 26 hours. Absolutely saved my business trip. Best service in the Houston metro.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "pearland-1",
      name: "Pearland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2700 Cullen Blvd",
      city: "Pearland",
      state: "TX",
      zip: "77581",
      phone: "(281) 485-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Pearland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Pearland facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "pearland-2",
      name: "Pearland Westside Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2900 Broadway St",
      city: "Pearland",
      state: "TX",
      zip: "77581",
      phone: "(281) 485-2119",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Pearland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves west Pearland and Shadow Creek Ranch. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "pearland-3",
      name: "Brazoria County Clerk — Pearland",
      type: "County Clerk Passport Acceptance",
      address: "111 E Locust St",
      city: "Angleton",
      state: "TX",
      zip: "77515",
      phone: "(979) 864-1200",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "20 miles south — Angleton, Brazoria County seat",
      website: "https://www.brazoriacountytx.gov/",
      websiteLabel: "Brazoria County Clerk",
      notes: "County seat facility. Accepts passport applications with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "pearland-4",
      name: "Friendswood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "308 Morningside Dr",
      city: "Friendswood",
      state: "TX",
      zip: "77546",
      phone: "(281) 482-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles southeast of Pearland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Friendswood and south Pearland. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "pearland-5",
      name: "Clear Lake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1515 SF Plaza",
      city: "Houston",
      state: "TX",
      zip: "77058",
      phone: "(281) 488-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles east of Pearland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large facility serving NASA/Clear Lake area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "pearland-6",
      name: "Alvin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 E House St",
      city: "Alvin",
      state: "TX",
      zip: "77511",
      phone: "(281) 331-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles south of Pearland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Alvin and south Brazoria County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Fastest Processing", agency: "24–48 hours", fpc: "Same day (emergencies only)" },
    { feature: "Appointment Required", agency: "No", fpc: "Yes — call NPIC, limited slots" },
    { feature: "Processing Speed", agency: "Guaranteed turnaround", fpc: "Same-day if approved (rare)" },
    { feature: "Document Review", agency: "Yes — we check before submission", fpc: "No — rejected if wrong" },
    { feature: "Travel to Agency", agency: "No — ship from home", fpc: "Yes — 30 min drive to Houston" },
    { feature: "Agent Support", agency: "Yes — dedicated agent assigned", fpc: "No — government clerk only" },
    { feature: "Status Updates", agency: "Yes — daily email updates", fpc: "No — no tracking provided" },
    { feature: "Guaranteed Timing", agency: "Yes — contractual turnaround", fpc: "No — subject to availability" },
    { feature: "Bay Area Houston Knowledge", agency: "Yes — local expertise", fpc: "Generic" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Pearland photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Brazoria County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Pearland applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Houston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Bay Area families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Pearland travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Pearland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Pearland address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Pearland before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Pearland for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the drive to downtown Houston." },
    { q: "How fast can I renew my passport in Pearland?", a: "Fast Passport Center offers fast passport renewal in Pearland in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Pearland?", a: "The nearest regional passport agency to Pearland is the Houston Passport Agency, approximately 20 miles north in downtown Houston via TX-288. For urgent processing without the Houston traffic, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Pearland without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Pearland?", a: "Same-day passport appointments are only available at the Houston Regional Passport Agency — approximately 30 minutes from Pearland — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Brazoria County residents." },
    { q: "Do you serve the entire Pearland and Bay Area Houston region?", a: "Absolutely. Fast Passport Center serves the entire Bay Area Houston region including Pearland, Friendswood, Manvel, Alvin, League City, Webster, Clear Lake, Pasadena, Deer Park, La Porte, and surrounding areas. Our courier service works seamlessly from any address in Brazoria County and the Houston metro." },
    { q: "Can I expedite a child passport in Pearland?", a: "Yes. Fast Passport Center expedites child passports in Pearland for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Brazoria County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Pearland with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Houston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Pearland", address: "2700 Cullen Blvd, Pearland, TX 77581", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Friendswood", address: "308 Morningside Dr, Friendswood, TX 77546", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Pearland", address: "2900 Broadway St, Pearland, TX 77581", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Clear Lake", address: "1515 SF Plaza, Houston, TX 77058", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Alvin", address: "301 E House St, Alvin, TX 77511", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Pearland", address: "2800 Broadway St, Pearland, TX 77581", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Texas DPS — Pearland",
      address: "4600 Broadway St, Pearland, TX 77581",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Texas DPS — Houston South",
      address: "4545 Dacoma St, Houston, TX 77092",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Large mega center serving south Houston. REAL ID available.",
      featured: false,
    },
    {
      name: "Texas DPS — Angleton",
      address: "111 E Locust St, Angleton, TX 77515",
      hours: "Mon–Fri: 8AM–5PM",
      note: "County seat facility. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HOU",
      name: "William P. Hobby Airport",
      distance: "15 miles north of Pearland",
      address: "7800 Airport Blvd, Houston, TX 77061",
      note: "Southwest Airlines hub with domestic and international flights to Mexico, Caribbean, and Central America. About 20 minutes from Pearland via I-45.",
      flightUrl: "https://www.fly2houston.com/hobby",
      flightLabel: "HOU Airport",
      featured: true,
    },
    {
      code: "IAH",
      name: "George Bush Intercontinental Airport",
      distance: "35 miles north of Pearland",
      address: "2800 N Terminal Rd, Houston, TX 77032",
      note: "Major international hub. United Airlines hub with direct flights worldwide. About 40 minutes from Pearland via I-45 and Beltway 8.",
      flightUrl: "https://www.fly2houston.com/iah",
      flightLabel: "IAH Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Texas Department of State Health Services (DSHS) Vital Statistics. Online, mail, or in-person options available.", url: "https://dshs.texas.gov/vs/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Texas DSHS Vital Statistics. Required for estate and legal matters.", url: "https://dshs.texas.gov/vs/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Brazoria County Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.brazoriacountytx.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Brazoria County District Clerk. Required for name change passport corrections.", url: "https://www.brazoriacountytx.gov/" },
  ],
};